var map = {
	"./01.png": 828,
	"./02.png": 829,
	"./03.png": 830,
	"./04.png": 831,
	"./05.png": 832,
	"./06.png": 833,
	"./07.png": 834,
	"./08.png": 835,
	"./09.png": 836,
	"./10.png": 837,
	"./11.png": 838,
	"./12.png": 839,
	"./13.png": 840,
	"./14.png": 841
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1201;